export default __webpack_public_path__ + "static/media/dispositivos.23f304c1.svg";